import type * as Types from 'app/types/graphql';

export type HeatmapScrollRowSelectFragment = Pick<
  Types.HeatmapScrollRow,
  | 'scrollReachPercent'
  | 'visitors'
  | 'percUsers'
  | 'dropOffPercent'
  | 'dwellTimeMs'
  | 'avgDwellTimeMs'
  | 'convertedSessions'
  | 'convertedVisitors'
  | 'orders'
  | 'revenue'
>;

export const HeatmapScrollRowSelectFragmentDoc = `
    fragment HeatmapScrollRowSelect on HeatmapScrollRow {
  scrollReachPercent
  visitors
  percUsers
  dropOffPercent
  dwellTimeMs
  avgDwellTimeMs
  convertedSessions
  convertedVisitors
  orders
  revenue
}
    `;
